export enum ApplicationRoutes {
  HOME = '/',
  LOGIN = '/login',
  SELECT_PBX = '/select-pbx',
  CALLS = '/calls',
  MESSAGING = '/messaging',
  VOICEMAIL = '/voicemails',
  FAX = '/faxes',
  CONTACTS = '/contacts',
  CALL_ANALYTICS = '/analytics',
  WEB_PHONE = '/web-phone',
  SETTINGS = '/settings',
  ICONS = '/icons',
  DASHBOARDS = '/dashboards',
}
